import siteLogo from "../assets/site-logo.svg";

export const authenticatorFields = {
  signIn: {
    username: {
      placeholder: "Enter your email",
      isRequired: true,
      label: "Email",
    },
    password: {
      placeholder: "Enter your password",
    },
  },
  resetPassword: {
    username: {
      placeholder: "Enter your email",
      isRequired: true,
      label: "Email",
    },
  },
};

export const authenticatorComponents = {
  Header() {
    return (
      <div className="w-full mt-20 mb-10 flex justify-center">
        <img src={siteLogo} alt="Policy Management Tool" className="w-72" />
      </div>
    );
  },
};
